<template>
  <div>
    <Header/>
    <div class="s_banner">
      <img src="https://cdn.gda.top/image_after_2019_06/2862/sctajik-logo1.jpg"/>
    </div>
    <div class="wrapper top230">
      <div class="s_top">
        <div class="nei_nav font18 pd60">{{$t('current_page')}} {{$t('news_center')}}</div>
        <div class="title pd60">{{$t('news_center')}}</div>
      </div>
      <div class="main">
        <div class="newsList" style="min-height:400px;">
          <div class="li" v-for="item in newDataList">
            <div class="date">
              <h2>{{item.create_time_d}}</h2>
              <p class="font18">{{item.create_time_y_m}}</p>
            </div>
            <div class="right">
              <h2> <router-link :to="{ name: 'NewsDetail', params: { id: item.id }}" style="padding-right: 20px;">{{item.title}}</router-link></h2>
              <p class="font18" name="abstractContent" v-html="item.content"></p>
            </div>
          </div>
        </div>
        <div style="">
          <div class="pages">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentNewsPage"
              @current-change="handleCurrentPageChange"
              :total="totalNum">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Footer from "../components/Footer";
  import Header from "../components/Header";

  export default {
    components: {Header, Footer},
    data() {
      return {
        newDataList: [],
        page: this.currentNewsPage,
        totalNum: 1,
        pageSize: 1
      }
    },
    mounted() {
      //回到顶部
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.page = this.currentNewsPage;
      this.reloadData();
    },
    methods: {
      filter(text) {
        var reg = /<[^<>]+>/g;//1、全局匹配g肯定忘记写,2、<>标签中不能包含标签实现过滤HTML标签
        text = text.replace(reg, '');//替换HTML标签
        text = text.replace(/&nbsp;/ig, '');//替换HTML空格
        return text;
      },
      handleCurrentPageChange(selectedPageNo){
        Vue.setStorageVariable({'news_page': selectedPageNo});
        this.page = selectedPageNo;
        this.reloadData();
      },
      reloadData(){
        this.getUrl('/official_website/news/news_list', {
          lang: this.currentLang,
          current_page: this.page
        }).then((response) => {
          if(response.data.code == 20000){
            for (var i = 0; i < response.data.data.length; i++) {
                response.data.data[i]['content'] = this.filter(response.data.data[i]['content']);
            }
            this.newDataList = response.data.data;
            this.page = response.data.current_page;
            this.totalNum = response.data.total_num;
            this.pageSize = response.data.page_size;
          }
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style scoped>
    a:hover {
        text-decoration: underline;
        text-decoration-color: #3e6be3;
        cursor: pointer;
    }
    .font18 a:hover{
        text-decoration: none;
        cursor: pointer;
    }
</style>
